module.exports = __webpack_public_path__ + "static/img/40006 (4).800284b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40006 (4).webp
// module id = WK6N
// module chunks = 14